import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRemoveBackground2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="remove-background-2"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M8 4V8H4V4H8Z" fill="currentColor"/><path d="M12 8V12H8V8H12Z" fill="currentColor"/><path d="M8 12V16H4V12H8Z" fill="currentColor"/><path d="M12 16V20H8V16H12Z" fill="currentColor"/><path d="M12 1V23" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconRemoveBackground2;
